<script setup lang="ts">
interface DividerBlockProps {
  title?: string;
  emphasize?: boolean;
  image?: any;
}

const props = defineProps<{ data: DividerBlockProps }>();
</script>
<template>
  <BlockContainer full-width class="px-4">
    <div v-if="data?.emphasize === true">
      <div class="flex items-center justify-between animate-fadeIn">
        <TypographyHeadline :content="data.title ?? ''" class="justify-left" />
        <NuxtImg
          v-if="data.image"
          :alt="data.image?.description ?? ''"
          :title="data.image?.description ?? ''"
          :src="safeRelationId(data.image) ? safeRelationId(data.image) : ''"
          class="rounded-card dark:brightness-90 p-1"
          width="133"
          height="100"
        />
      </div>
      <div class="w-full h-1 bg-primary-500 dark:bg-primary-500 animate-growRight"/>

      <!-- <div v-if="data.title" class="flex-shrink-0 mx-auto lg:mx-0 ">
        <TypographyHeadline :content="data.title" />
      </div>
      <div class="w-full h-px bg-primary-300 dark:bg-primary-700"></div> -->
    </div>
    <div v-if="data?.emphasize === false">
      <div v-if="data.title" class="flex-shrink-0 mx-auto lg:mx-0">
        <TypographyHeadline :content="data.title" />
      </div>
      <div class="w-full h-px bg-gray-300 dark:bg-gray-700"/>
    </div>
  </BlockContainer>
</template>
<style scoped>
@property --border-angle {
  inherits: false;
  initial-value: 0deg;
  syntax: '<angle>';
}
</style>
